module.exports = __webpack_public_path__ + "static/media/coinmercury.61c9c632.jpeg";